import advancedListSaga from './advancedListSaga'
import copiableListSaga from './copiableListSaga'
import assignedListSaga from './assignedListSaga'
import checkInOutSaga from './checkInOutSaga'
import contactByTokenSaga from './contactByTokenSaga'
import contactListVerifySaga from './contactListVerifySaga'
import contactsStatusStatisticsSaga from './contactsStatusStatisticsSaga'
import contactVerifySaga from './contactVerifySaga'
import deleteContactSaga from './deleteSaga'
import editSaga from './editSaga'
import externalContactSaga from './externalContactSaga'
import externalEmployeesSaga from './externalEmployeesSaga'
import getPreSignedUploadURLSaga from './getPreSignedUploadURLSaga'
import listSaga from './listSaga'
import moveToCompanySaga from './moveToCompany'
import oneContactSaga from './oneContactSaga'
import revealSaga from './revealSaga'
import searchSaga from './searchSaga'
import uploadImageSaga from './uploadImageSaga'
import countSaga from './countSaga'
import externalContactCheckInfoSaga from './externalContactCheckInfoSaga'
import externalContactRevealInfoSaga from './externalContactRevealInfoSaga'
import externalContactRevealSaga from './externalContactRevealSaga'
import copyInfoSaga from './copyInfoSaga'
import copySaga from './copySaga'
import copyStatusSaga from './copyStatusSaga'

const companiesSagas = [
    listSaga(),
    oneContactSaga(),
    externalContactSaga(),
    editSaga(),
    assignedListSaga(),
    advancedListSaga(),
    copiableListSaga(),
    getPreSignedUploadURLSaga(),
    uploadImageSaga(),
    deleteContactSaga(),
    moveToCompanySaga(),
    checkInOutSaga(),
    contactByTokenSaga(),
    contactsStatusStatisticsSaga(),
    searchSaga(),
    contactVerifySaga(),
    contactListVerifySaga(),
    revealSaga(),
    externalEmployeesSaga(),
    countSaga(),
    externalContactCheckInfoSaga(),
    externalContactRevealInfoSaga(),
    externalContactRevealSaga(),
    copyInfoSaga(),
    copySaga(),
    copyStatusSaga()
]

export default companiesSagas
